import { DSLinkButton } from "@components/design-system/molecules";

import AddTeamInformation from "../../team/ModalScreens/AddTeamInformation";
import StepWrapper from "../StepWrapper";

export default function TeamCreateStep({
  teamName,
  setTeamName,
  setTeamLocation,
  error,
  onSkip,
}) {
  return (
    <StepWrapper
      title="Let's Set Up Your Team"
      description="Tell us about your clinic so we can create the perfect team workspace for you."
    >
      <AddTeamInformation
        teamName={teamName}
        setTeamName={setTeamName}
        setTeamLocation={setTeamLocation}
        error={error}
      />
      {onSkip && (
        <div className="mt-4">
          <DSLinkButton
            onClick={onSkip}
            dataTestId="skip-team-create"
          >
            I’ll do this later
          </DSLinkButton>
        </div>
      )}
    </StepWrapper>
  );
}
